import {apiCredential} from "../../../../libraries/api-credential";
import {ContentType} from "ct-library-api-credential";
import {
  clearSessionRequest,
  clearSessionResponse,
  fetchSessionStatusRequest,
  fetchSessionStatusResponse,
} from "../types/session.type";

export const SessionAPI = {
  fetchSessionStatus: async (
    request: fetchSessionStatusRequest,
  ): Promise<fetchSessionStatusResponse> => {
    try {
      const response = await apiCredential.call<fetchSessionStatusResponse>({
        path: `/api/v1/sessions/status`,
        method: "GET",
        format: "json",
        type: ContentType.Json,
        query: request.query,
        credentials: "include",
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  clearSession: async (
    _request: clearSessionRequest,
  ): Promise<clearSessionResponse> => {
    try {
      const response = await apiCredential.call<clearSessionResponse>({
        path: `/api/v1/sessions/clear-session`,
        method: "POST",
        format: "json",
        type: ContentType.Json,
        credentials: "include",
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
